module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Medium.1e07dd93.woff";